import { BaseHttpResponse } from '@rogers/self-serve-common';

export interface AutopayEligibility {
  account: string;
  autopayEligible: boolean;
}
export interface AutopayPromoResponse extends BaseHttpResponse {
  promotions: AutopayPromotions[];
}

export interface AutopayPromotions {
  value: number;
  UOM: string;
  effectiveDate: string;
  expirationDate: string;
  subscribers: EligibleSubscribers[];
}

export interface EligibleSubscribers {
  name: string;
  subNumber: string;
}

export interface AutopayPromoDetails {
  isEnroll?: boolean;
  modalHeading: string;
  modalBody: string;
  discountMessage?: string;
  promotions: AutopayPromotions[];
}
export const ELIGIBLE_IND_LIST = ['UWP', 'XEWP', 'XEEP'];
export const ELIGIBLE_PRODUCT_TYPES = ['Wireless', 'Multi-product'];
